import React from "react";
import { Checkbox } from "@material-ui/core";
import { CheckboxProps } from "@material-ui/core/Checkbox/Checkbox";
import clsx from "clsx";
import { ReactComponent as CheckedIcon } from "common-assets/assets/icons/checkboxIcon-check.svg";

import useStyles from "./Checkbox.style";

export interface CustomCheckboxProps extends CheckboxProps {
  className?: string;
  hideIcon?: boolean;
  hasError?: boolean;
  required?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  className,
  hideIcon = false,
  hasError = false,
  required = false,
  ...props
}) => {
  const c = useStyles({ disabled: props.disabled, hideIcon, hasError });

  return (
    <Checkbox
      {...props}
      disabled={props.disabled}
      classes={{
        root: clsx(c.root, hasError && c.error, className),
      }}
      inputProps={{
        ...props.inputProps,
        "aria-required": required,
      }}
      icon={<CheckedIcon className={c.checkboxIcon} />}
      checkedIcon={<CheckedIcon className={c.checkedIcon} />}
    />
  );
};

export { CustomCheckbox as Checkbox };
